import { useQuery } from "@tanstack/react-query";
import { client } from "@johnpaul/jp-api-client";
import { ComponentData, JPClientRequest } from "@companion-core/shared/app/Interfaces/API";

type RecommendedListParams = {
  from?: string;
  radius?: number;
  tags?: string[];
  lang?: string;
  contentType?: string;
  isLocked?: boolean;
  type?: string;
  enabled?: boolean;
};

export const useRecommendedList = ({
  from,
  radius,
  tags,
  lang,
  contentType,
  type,
  isLocked,
  enabled = true,
}: RecommendedListParams) => {
  return useQuery({
    queryKey: ["recommended-list", from, radius, tags, lang, contentType, type, isLocked],
    enabled,
    retry: false,
    queryFn: () =>
      client.content.v2.components.get(null, {
        ...(from ? { from, km: radius } : {}),
        lang,
        // eslint-disable-next-line camelcase
        page_size: 3,
        // eslint-disable-next-line camelcase
        content_ct: contentType,
        ...(tags !== undefined && { tags: tags?.join(",") }),
        ...(isLocked !== undefined && {
          // eslint-disable-next-line camelcase
          is_locked: isLocked,
        }),
        ...(type !== undefined && { type }),
      }),
    select: (data: JPClientRequest<ComponentData>): ComponentData[] =>
      data?.data?.results?.length > 0 ? data.data.results : [],
  });
};
